<script>
    import { doc, onSnapshot, updateDoc, deleteField, addDoc, setDoc, deleteDoc, query, collection, where, serverTimestamp, orderBy} from "firebase/firestore";
    import { getStorage, ref, deleteObject } from "firebase/storage";
    import { db } from "../../firebase/firestore";
    import { user } from "../../firebase/auth";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import DumbGallery from "./DumbGallery.svelte";
    import Button from "../ui/Button.svelte";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let businessId;
    export let imgSize = {x: 360, y: 360};
    export let name = "Bild";
    export let type = "avatar";
    export let selection;
    export let min = 1;    
    
    const storage = getStorage();
    const businessRef = doc(db, "businesses", businessId); 

    let imgs_preset = [];
    const unsub1 = onSnapshot(query(collection(db, "imgs"), where("type", "==", type), where("preset", "==", true), orderBy("created", "desc")), (snap) => {
        imgs_preset = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    })
    
    let imgs_business = [];
    const unsub2 = onSnapshot(query(collection(db, "imgs"), where("type", "==", type), where("business", "==", businessId), orderBy("created", "desc")), (snap) => {
        imgs_business = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    })

    // Get current selection
    onSnapshot(businessRef, (doc) => {
        selection = doc.data().images[type];
    });


    function confirm() {
        updateDoc(businessRef, {
            [`images.${type}`]: selection ?? deleteField()
        });
        dispatch("confirm");
    }

    function toggle(e) {
        let image = e.detail.image;
        if ((!min || min == 0) && image.src == selection) {
            selection = undefined;
        } else {
            selection = image.src;
        }
    }

    function cancel() {
        // TODO: reset images (so the selections are reset)
        dispatch("cancel");
    }

    async function del(e) {
        console.log(e);
        const imageRef = ref(storage, "images/"+e.detail.path);
        deleteObject(imageRef);
        
        await deleteDoc(doc(db, "imgs",  e.detail.id));
        
        if(selection === e.detail.src) {
            if(imgs_business.length > 0) {
                updateDoc(businessRef, {
                    [`images.${type}`]: imgs_business[0].src
                });
            } else if(imgs_preset.length > 0) {
                updateDoc(businessRef, {
                    [`images.${type}`]: imgs_preset[0].src
                });
            } else {
                updateDoc(businessRef, {
                    [`images.${type}`]: deleteField()
                });
            }
        }
    }

    async function uploadFinished(e) {
        const newImg = {
            type,
            src: e.detail.src,
            path: e.detail.path,
            created: serverTimestamp(),
            business: businessId,
        }
        await addDoc(collection(db, "imgs"), newImg);
        selection = e.detail.src;
    }

    let edit = false;
</script>


<Dialog class="dialog" open={edit} on:close={cancel} static>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">{name} aktualisieren</DialogTitle>
        <DialogDescription class="dialog-description">
            Wähle dein {name} aus, oder lade neue Bilder hoch.
        </DialogDescription>

        <DumbGallery bind:images={imgs_preset} bind:selection on:toggle={toggle} editable={false} {imgSize}/>
        <DumbGallery bind:images={imgs_business} bind:selection on:toggle={toggle} on:uploadFinished={(e) => {uploadFinished(e)}} on:del={(e) => {del(e)}} {imgSize}/>
        
        <div class="dialog-options">
            <Button on:click={cancel}>
                Abbrechen
            </Button>
            <Button intent="primary" on:click={confirm}>
                Bestätigen
            </Button>
        </div>
    </div>
</Dialog>